module.exports = __webpack_public_path__ + "static/img/250.d1973d5d.png";